export const charCounter = (value = '', max, threshold = 20) => {
  const remaining = Math.max(0, max - value.length);
  return { remaining, showCounter: remaining <= threshold };
};
